/**
 * 采购差额调账的新增页面 货品配置处理
 * @author zjs
 * @time 2017-10-12
 */
export default {
    data () {
        return {
            productConfig: [{
                prop: 'product',
                label: '货品编码',
                width: 120,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_cai'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'ip_code',
                label: 'IP码',
                width: 100,
                component: 'ElInput'
            }, {
                prop: 'product',
                label: '货品名称',
                width: 275,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_name'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'product',
                label: '单位',
                json: {
                    prop: 'product_unit'
                },
                width: '50'
            }, {
                prop: 'tzce_amount',
                label: '调账差额',
                width: '150',
                default: 0,
                json: {
                    min: -Infinity
                },
                component: 'LyInputNumber'
            }, {
                prop: 'tzcb_price',
                label: '参考调账后成本单价',
                width: '150'
            }, {
                prop: 'tzcg_amount',
                label: '调账前采购总额',
                width: '150'
            }, {
                prop: 'caigoud',
                label: '调账单据',
                width: '100',
                default: [],
                component: 'LyAdjustOrder'
            }, {
                type: 'function',
                func: function (list, callback) {
                    list.forEach(function (el) {
                        let product = el.product
                        // 这里判断有问题，修改之 2018-06-28
                        // if ((el.tzce_amount === 0 || el.tzce_amount === '0') && product.tzce_amount) {
                        if (!el.tzce_amount && product.tzce_amount) {
                            el.tzce_amount = product.tzce_amount
                        }
                        // 计算调账后成本单价
                        if (product.total_quantity_cetz &&
                            !isNaN(product.total_amount) && !isNaN(product.total_quantity_cetz)) {
                            let tzce = parseFloat(el.tzce_amount)
                            let amount = parseFloat(product.total_amount)
                            let quantity = parseFloat(product.total_quantity_cetz)
                            el.tzcb_price = ((tzce + amount) / quantity).toFixed(2)
                        } else {
                            el.tzcb_price = '0'
                        }
                        // 计算调账前采购总额
                        let amount = 0
                        el.caigoud.forEach((item) => {
                            let price = parseFloat(item.amount)
                            if (item.type === 4) {
                                amount = parseFloat(parseFloat(amount) + price).toFixed(2)
                            } else {
                                amount = parseFloat(parseFloat(amount) - price).toFixed(2)
                            }
                        })
                        el.tzcg_amount = amount
                        // 2017-12-15 参考调账后成本单价 修改为 “提交后查看”
                        // 产品专卖发邮件说的，与25批一起更新
                         el.tzcb_price = '提交后查看'
                    })
                    callback()
                }
            }]
        }
    }
}